module.exports = __webpack_public_path__ + "static/media/stove.7f99c87c.svg";